import { Layout } from "components/common"
import useStore from "components/ui/Context"
import { useEffect } from "react"

export default function Security() {
  const { isShowModalLogin, togleModalLogin } = useStore()

  useEffect(() => {
    if (isShowModalLogin) {
      togleModalLogin(false)
    }
  }, [isShowModalLogin])
  return (
    <section className="max-w-screen-sm m-auto text-dark-300 md:mt-4 p-4">
      <h1 className="m-auto font-semibold text-lg mb-4">CHÍNH SÁCH BẢO MẬT & ĐIỀU KHOẢN SỬ DỤNG</h1>
      <p className="mb-4 text-justify">
        On Plus luôn tôn trọng sự riêng tư của bạn, và đó là lý do chúng tôi luôn cam kết bảo vệ những thông tin cá nhân
        của bạn. Trong tài liệu này, khái niệm “thông tin cá nhân” được hiểu bao gồm tên, địa chỉ, địa chỉ email, số
        điện thoại hay bất kỳ thông tin cá nhân nào khác mà bạn cung cấp, hoặc bất kỳ thông tin nào về bạn được thu thập
        theo luật định hiện hành. Mong rằng tài liệu sẽ giúp bạn hiểu rõ những thông tin cá nhân nào mà chúng tôi sẽ thu
        thập, cũng như cách chúng tôi sử dụng những thông tin này sau đó. Khi bạn truy cập và sử dụng trang web (bao gồm
        cả việc đăng ký dịch vụ trực tuyến), chúng tôi hiểu rằng bạn hoàn toàn đồng ý với những điều khoản của chính
        sách này.
      </p>
      <h2 className="font-semibold mb-2">1. KHAI BÁO KHI SỬ DỤNG</h2>
      <p className="mb-4 text-justify">
        Tất cả nội dung bạn xem được trên ON Plus nhằm phục vụ nhu cầu thông tin của bạn và giúp bạn lựa chọn dịch vụ.
        Vì thế, bạn được sử dụng ON Plus mà không cần cung cấp bất kỳ thông tin cá nhân nào. Tuy nhiên, trong một số
        trường hợp, khi liên quan đến việc đăng ký dịch vụ, chúng tôi có thể yêu cầu bạn cung cấp thông tin cá nhân.
      </p>
      <h2 className="font-semibold mb-2">2. THÔNG TIN CÁ NHÂN DO BẠN CUNG CẤP</h2>
      <p className="mb-4 text-justify">
        Khi bạn cung cấp các thông tin cần thiết, chúng tôi sẽ sử dụng chúng để đáp ứng yêu cầu của bạn, hoặc chúng tôi
        có thể liên lạc với bạn qua thư từ, email, tin nhắn hay điện thoại; hoặc tuân theo luật định hiện hành, sử dụng
        các phương tiện trên để giới thiệu đến bạn những sản phẩm, dịch vụ hay chương trình khuyến mãi mới từ ON Plus.
        Khi cung cấp thông tin cho chúng tôi qua ON Plus, bạn hiểu rõ và chấp thuận việc thu thập, sử dụng và tiết lộ
        những thông tin cá nhân nêu trên cho một số mục đích được quy định trong trang này. Bạn hoàn toàn đồng ý và chấp
        thuận rằng những thông tin cá nhân bạn cung cấp khi sử dụng ON Plus có thể được bảo lưu tại trụ sở hay của ON
        Plus, có thể được lưu trữ tại một số máy chủ hiện có hay chưa biết trước cho mục đích vận hành và phát triển ON
        Plus cũng như các dịch vụ của ON Plus. Chúng tôi sẽ không cung cấp thông tin của bạn cho một bên thứ ba mà không
        được sự cho phép của bạn, trừ trường hợp bị pháp luật hiện hành bắt buộc hoặc trường hợp cần thiết để xử lý các
        vấn đề liên quan đến pháp luật. ON Plus cam kết bảo vệ sự riêng tư của bạn, không mua bán thông tin cá nhân của
        bạn cho các công ty khác vì các mục đích khuyến mãi.
      </p>
      <h2 className="font-semibold mb-2">ON Plus Sẽ Thu Thập Những Thông Tin Gì Và Sử Dụng Chúng Như Nào?</h2>
      Theo quy định của pháp luật Việt Nam và nhằm tối ưu hóa dịch vụ được cung cấp cho bạn, ON Plus sẽ thu thập và lưu
      trữ các thông tin sau đây:
      <p className="mb-4 text-justify">
        <br />
        <br />
        <table className="table">
          <thead>
            <tr>
              <th className="p-2">Thông tin cá nhân</th>
              <th className="p-2">Sử dụng</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2">Tên đăng nhập</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này để tạo tài khoản cho ON Plus theo yêu cầu của bạn.
              </td>
            </tr>
            <tr>
              <td className="p-2">
                Thông tin kết nối xã hội: <br /> Facebook: Tên, ID Facebook, ảnh hồ sơ <br /> Google: Biệt hiệu, ảnh hồ
                sơ
              </td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này để: tạo tài khoản cho ON Plus theo yêu cầu của bạn; chia sẻ ảnh trong
                ứng dụng trên Facebook theo yêu cầu của bạn.
              </td>
            </tr>
            <tr>
              <td className="p-2">Open ID đã tạo</td>
              <td className="p-2">
                Chúng tôi tạo dữ liệu này và sử dụng dữ liệu này để lưu trữ dữ liệu của bạn (lích sử xem và tiến trình)
                cùng với hồ sơ của bạn.
              </td>
            </tr>
            <tr>
              <td className="p-2">Địa chỉ IP</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này để cải thiện các dịch vụ của mình, bao gồm cả chức năng của ON Plus.
              </td>
            </tr>
            <tr>
              <td className="p-2">ID thiết bị, thông tin thiết bị</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này: để cải thiện các dịch vụ của mình, bao gồm cả chức năng của ON Plus;
                cho các mục đích bảo mật và xác minh; xác định và giải quyết các lỗi và đánh giá chức năng để tối ưu
                hóa; và để chống lại việc người dùng đăng ký nhiều tài khoản.
              </td>
            </tr>
            <tr>
              <td className="p-2">Thông tin liên quan đến bảo mật</td>
              <td className="p-2">
                Chúng tôi sử dụng thông tin này: cho mục đích bảo mật và xác minh; xác định và giải quyết các lỗi và
                đánh giá chức năng để tối ưu hóa hành động; giải quyết lỗi ứng dụng và tối ưu hóa khả năng tương thích
                của thiết bị với ứng dụng; và để chống lại việc người dùng đăng ký nhiều tài khoản.
              </td>
            </tr>
            <tr>
              <td className="p-2">Thông tin khảo sát và nội dung của các câu trả lời khảo sát</td>
              <td className="p-2">Chúng tôi sử dụng thông tin này để cải thiện dịch vụ của mình.</td>
            </tr>
          </tbody>
        </table>
        <br />
        Theo quy định của pháp luật Việt Nam, toàn bộ thông tin cá nhân và dữ liệu của bạn sẽ được lưu trữ tối thiểu hai
        (2) năm kể từ thời điểm bạn cung cấp thông tin và/hoặc tạo ra dữ liệu.
        <br />
        <br /> ON Plus có quyền sử dụng các thông tin nêu trên để gửi đến bạn các tin nhắn, thư điện tử (email), gọi
        điện thoại và/hoặc liên hệ với bạn theo bất kỳ cách thức nào mà ON Plus lựa chọn sử dụng nhằm:
        <br /> - Hỗ trợ, cung ứng các dịch vụ tốt nhất cho bạn <br /> - Gửi đến bạn các thông tin, nội dung nhằm mục
        đích quảng cáo dịch vụ của ON Plus <br /> - Phân tích, đo lường hiệu quả các dịch vụ mà bạn sử dụng <br /> -
        Liên hệ trực tiếp với bạn để nhằm mục đích chăm sóc khách hàng, xác thực thông tin và các mục đích khác. <br />{" "}
        <br />
        ON Plus sẽ cung cấp, chia sẻ các thông tin cá nhân, dữ liệu và/hoặc các thông tin khác của bạn mà ON Plus lưu
        trữ trong các trường hợp sau đây:
        <br />- Được sự đồng ý của bạn. <br /> - Theo yêu cầu của Tòa án và/hoặc Cơ quan Nhà nước có thẩm quyền.
        <br /> <br />
        ON Plus sẽ thực hiện các biện pháp kỹ thuật cần thiết để bảo mật thông tin của bạn, bao gồm không giới hạn ở
        việc (I) mã hóa thông tin theo tiêu chuẩn phù hợp, (II) thiết lập các hệ thống tường lửa để ngăn chặn việc xâm
        nhập trái phép, (III) sử dụng dịch vụ máy chủ, chỗ đặt máy chủ tại các đơn vị, doanh nghiệp có tiêu chuẩn bảo
        mật cao.
      </p>
      <h2 className="font-semibold mb-2">3. CUNG CẤP CHO CÁC ĐƠN VỊ KHÁC</h2>
      <p className="mb-4 text-justify">
        Chúng tôi có thể sử dụng một số đơn vị khác để cung cấp sản phẩm hay dịch vụ cho bạn. Chúng tôi cũng cần trao
        đổi thông tin cá nhân của bạn đến các đơn vị này để họ hoàn thành yêu cầu của bạn. Những đơn vị này cũng không
        được phép sử dụng thông tin cá nhân của bạn cho các mục đích khác và chúng tôi đồng thời yêu cầu họ tuân theo
        quy định bảo mật khi tiến hành cung cấp dịch vụ.
      </p>
      <h2 className="font-semibold mb-2">4. GHI NHẬN THÔNG TIN TRÌNH DUYỆT</h2>
      <p className="mb-4 text-justify">
        Đôi khi, thông tin có thể được đưa vào máy tính của bạn để giúp chúng tôi nâng cấp ON Plus hay cải thiện chất
        lượng dịch vụ cho bạn. Những thông tin này thường được biết đến dưới dạng các “cookies” mà nhiều ON Plus hiện
        cũng đang sử dụng. “Cookies” là những mẩu thông tin lưu trữ trong đĩa cứng hay trình duyệt trên máy tính của
        bạn, không phải trên ON Plus. Chúng cho phép thu thập một số thông tin về máy tính của bạn như địa chỉ IP, hệ
        điều hành, chế độ trình duyệt và địa chỉ của các ON Plus liên quan. Nếu bạn không muốn nhận các cookies này,
        hoặc muốn được thông báo khi các cookies này được đặt vào, bạn có thể cài đặt chế độ trình duyệt của bạn thực
        hiện điều này nếu trình duyệt của bạn hỗ trợ. Vui lòng lưu ý, nếu bạn tắt chế độ nhận cookies, bạn sẽ không thể
        truy cập hay sử dụng một số tiện ích trên ON Plus mà không được xác định trước. Chúng tôi không cố ý hạn chế
        việc sử dụng của bạn trong tình huống này, đây chỉ là giới hạn trong việc lập trình và xây dựng ON Plus.
      </p>
      <h2 className="font-semibold mb-2">5. AN TOÀN THÔNG TIN</h2>
      <p className="mb-2 text-justify">
        Khi lập trình ON Plus, chúng tôi có thể đặt những luật định hợp lý mang tính thương mại để ngăn chặn hành vi
        truy cập bất hợp pháp và việc sử dụng không thích đáng các thông tin cá nhân của bạn đã gửi cho ON Plus thông
        qua việc sử dụng ON Plus. Vì luôn có những rủi ro liên quan đến vấn đề cung cấp dữ liệu cá nhân, cho dù là cung
        cấp trực tiếp, qua điện thoại hay qua mạng internet, hay qua các phương tiện kỹ thuật khác; và không có hệ thống
        kỹ thuật nào an toàn tuyệt đối hay chống được tất cả các “hacker” và “tamper” (người xâm nhập trái phép để lục
        lọi thông tin), ON Plus luôn nỗ lực tiến hành những biện pháp đề phòng thích hợp đối với từng đặc tính của thông
        tin để ngăn chặn và giảm thiểu tối đa các rủi ro có thể khi bạn sử dụng ON Plus.
      </p>
      <p className="mb-4 text-justify">
        <p className="font-semibold mb-2">GIỚI HẠN THIẾT BỊ TƯƠNG THÍCH</p>
        <p>
          Hiệu năng của ứng dụng On Plus phụ thuộc vào mẫu điện thoại, máy tính bảng, smart TV, thiết bị thông minh
          Android mà bạn sử dụng, bên cạnh đó là hệ điều hành, phiên bản hệ điều hành, ngôn ngữ, nhà mạng của bạn. Để
          tìm hiểu hệ điều hành được ứng dụng On Plus hỗ trợ vui lòng xem dưới đây:
        </p>
        <p>iOS (Apple Smartphone): iOS 11.0 hoặc mới hơn.</p>
        <p>Android (Android Smartphone/Tablet): Android 7 hoặc mới hơn.</p>
        <p>iPadOS (Apple iPad): iPadOS 11.0 hoặc mới hơn.</p>
        <p>WebOS (Smart TV): WebOS 4 hoặc mới hơn.</p>
        <p>Tizen (Smart TV): Tizen 4 hoặc mới hơn (Smart TV Samsung model sau thời điểm 2018)</p>
        <p>Android TV (Smart TV): Android TV 6 hoặc mới hơn.</p>
        <p>Trình duyệt web: Chrome, Edge, Firefox.</p>
        <p>
          On Plus không giải quyết các khiếu nại liên quan đến hiệu năng hoặc nội dung cung cấp của ứng dụng trên các
          thiết bị đã rooted, jailbreak, hack.{" "}
        </p>
      </p>
      <h2 className="font-semibold mb-2">6. THÔNG TIN QUA EMAIL</h2>
      <p className="mb-4 text-justify">
        Khi bạn đăng ký dịch vụ, địa chỉ email của bạn cung cấp sẽ dùng làm công cụ trao đổi thông tin với bạn. Trước
        hết bạn hãy chắc rằng bạn cung cấp địa chỉ email hữu dụng đối với bạn trong suốt quá trình sử dụng dịch vụ.
        Chúng tôi có thể gửi những thông tin bí mật qua email hay tiếp nhận yêu cầu hỗ trợ của bạn. Trong trường hợp bạn
        không còn sử dụng email đã cung cấp, bạn phải báo cho chúng tôi để về việc thay đổi này. Để bảo vệ bạn, ON Plus
        có thể tạm thời ngừng tiếp nhận yêu cầu qua email bạn đã cung cấp nếu nhận thấy có sự gian lận hoặc thông tin
        bất thường - cho đến khi chúng tôi liên hệ được với bạn để xác nhận.
      </p>
      <h2 className="font-semibold mb-2">7. ĐIỀU CHỈNH THÔNG TIN</h2>
      <p className="mb-4 text-justify">
        On Plus sẽ chủ động hoặc theo yêu cầu của bạn bổ sung, hiệu chỉnh hay tẩy xóa các dữ liệu thông tin cá nhân
        không chính xác, không đầy đủ hoặc không cập nhật khi bạn còn liên kết với hoạt động của chúng tôi.
      </p>
      <h2 className="font-semibold mb-2">8. LIÊN KẾT NGOÀI TRANG WEB</h2>
      <p className="mb-4 text-justify">
        ON Plus có thể chứa các đường liên kết đến các ON Plus khác được đặt vào nhằm mục đích giới thiệu hoặc bổ sung
        thông tin liên quan để bạn tham khảo. ON Plus không chịu trách nhiệm về nội dung hay các hành vi của bất kỳ ON
        Plus nào khác.
      </p>
      <h2 className="font-semibold mb-2">9. THAY ĐỔI QUY ĐỊNH</h2>
      <p className="mb-4 text-justify">
        On Plus có thể thay đổi quy định này một cách không thường xuyên, bao gồm việc bổ sung, loại bỏ một phần nội
        dung hoặc tạm ngưng trang web mà không cần báo trước. Tuy nhiên, nếu quy định này được thay đổi theo hướng có
        thể gây bất lợi cho bạn, On Plus sẽ cố gắng thông báo về sự thay đổi qua email bạn đã cung cấp hoặc ngay trên
        trang chủ.
      </p>
      <h2 className="font-semibold mb-2">10. XÓA THÔNG TIN VÀ TÀI KHOẢN TRÊN HỆ THỐNG</h2>
      <p className="mb-4 text-justify">
        10.1. Quyền xóa thông tin tài khoản:
        <br /> <br />
        10.1.1. Bạn có thể tự xóa/yêu cầu xóa thông tin của mình đã đăng ký với ON Live TV hoặc xóa tài khoản của mình
        bằng cách các cách thức như sau: <br /> - Thực hiện thao tác xóa tài khoản trên thiết bị đã đăng nhập tài khoản
        muốn xóa, lưu ý: khi bạn thực hiện &quot;Xác nhận&quot; đồng nghĩa với việc đồng ý với các điều khoản trong việc
        xóa tài khoản đã được nêu. <br /> - Gửi yêu cầu bằng văn bản hoặc email cho bộ phận CSKH của chúng tôi tại địa
        chỉ info@vtvcab.vn và trực tiếp qua hotline 1800 1091 / 1900 1515. Chúng tôi sẽ xử lý yêu cầu của bạn theo Chính
        sách Bảo mật cũng như các quy định pháp luật hiện hành.
        <br /> <br />
        10.1.2. Khi yêu cầu xóa thông tin, bạn đồng ý rằng: <br />
        Chúng tôi sẽ không thể tiếp tục cung cấp dịch vụ cho bạn. <br />
        Việc xóa tài khoản có thể dẫn đến việc chấm dứt quan hệ hiện tại giữa bạn và chúng tôi, cũng như các hợp đồng
        liên quan mà không phát sinh bất kỳ trách nhiệm bồi thường nào từ phía chúng tôi.
        <br /> <br />
        10.2. Quyền yêu cầu truy cập và chỉnh sửa thông tin
        <br /> <br />
        10.2.1. Nếu bạn đã đăng ký tài khoản với chúng tôi, bạn có thể: <br />
        Truy cập và chỉnh sửa dữ liệu cá nhân của mình thông qua mục Thiết lập tài khoản trên ứng dụng. <br />
        Nếu bạn chưa đăng ký tài khoản nhưng vẫn muốn kiểm tra hoặc chỉnh sửa thông tin cá nhân mà chúng tôi đang lưu
        trữ, bạn có thể gửi yêu cầu bằng văn bản đến info@vtvcab.vn. <br />
        Lưu ý: Chúng tôi có thể yêu cầu bạn cung cấp thông tin xác thực để đảm bảo quyền truy cập hoặc chỉnh sửa thông
        tin thuộc về chính chủ.
        <br /> <br />
        10.2.2. Chúng tôi bảo lưu quyền từ chối chỉnh sửa dữ liệu cá nhân trong các trường hợp: <br />
        Theo quy định của pháp luật về bảo vệ thông tin cá nhân. <br />
        Khi các điều luật hiện hành cho phép hoặc yêu cầu chúng tôi từ chối chỉnh sửa thông tin trong một số trường hợp
        nhất định.
        <br /> <br />
      </p>
    </section>
  )
}

Security.Footer = Layout
